// CourseForm.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const dummyCourses = [
  {
    id: 1,
    title: 'Intro to Web Development',
    instructor: 'Aisha Thomas',
    category: 'Frontend',
    enrolled: 120,
    status: 'active',
    aiEnabled: true
  },
  {
    id: 2,
    title: 'Python for Beginners',
    instructor: 'Samuel K.',
    category: 'Backend',
    enrolled: 90,
    status: 'archived',
    aiEnabled: false
  },
  {
  id: 3,
  title: 'Digital Communication',
  instructor: 'AI Tutor',
  category: 'Digital Literacy',
  enrolled: 10,
  status: 'active',
  aiEnabled: true
},
];

export const CourseForm = ({ initialData = {}, onSave }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: initialData.title || '',
    instructor: initialData.instructor || '',
    category: initialData.category || '',
    enrolled: initialData.enrolled || 0,
    status: initialData.status || 'active',
    aiEnabled: initialData.aiEnabled || false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    navigate('/admin/courses');
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">{initialData.id ? 'Edit Course' : 'Create New Course'}</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block font-medium">Title</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
        </div>
        <div>
          <label className="block font-medium">Instructor</label>
          <input
            type="text"
            name="instructor"
            value={formData.instructor}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
        </div>
        <div>
          <label className="block font-medium">Category</label>
          <input
            type="text"
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
            required
          />
        </div>
        <div>
          <label className="block font-medium">Enrolled</label>
          <input
            type="number"
            name="enrolled"
            value={formData.enrolled}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>
        <div>
          <label className="block font-medium">Status</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="active">Active</option>
            <option value="paused">Paused</option>
            <option value="archived">Archived</option>
          </select>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            name="aiEnabled"
            checked={formData.aiEnabled}
            onChange={handleChange}
          />
          <label className="font-medium">Enable AI Tutor</label>
        </div>
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
        >
          Save Course
        </button>
      </form>
    </div>
  );
};

export const CourseFormWrapper = ({ onSave }) => {
  const { id } = useParams();
  const courseId = parseInt(id);
  const course = dummyCourses.find(c => c.id === courseId);
  const handleUpdateCourse = (updatedData) => {
    const updatedCourses = dummyCourses.map(course =>
      course.id === courseId ? { ...course, ...updatedData } : course
    );
    console.log("Updated Courses:", updatedCourses);
    onSave(updatedData);
  };
  return <CourseForm initialData={course} onSave={handleUpdateCourse} />;
};

export const handleAddCourse = (newCourse) => {
  const newId = dummyCourses.length + 1;
  const courseWithId = { id: newId, ...newCourse };
  dummyCourses.push(courseWithId);
  console.log("Added Course:", courseWithId);
};

export default CourseForm;
